document.addEventListener(
  "click",
  async function (e) {
    const btn = e.target.closest(
      ".swym-storefront-layout-grid-item-add-to-cart-button",
    );
    if (!btn) return;
    if (btn.hasAttribute("data-swym-disabled")) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    btn.disabled = true;
    btn.setAttribute("data-swym-disabled", "true");

    let variantId = null;
    const parentItem = btn.closest("swym-storefront-layout-item");
    if (parentItem && parentItem.dataset.epi) {
      variantId = parentItem.dataset.epi;
    }

    if (!variantId) {
      alert("Не знайдено ID варіанту товару");
      btn.disabled = false;
      return;
    }

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    if (
      window.theme &&
      window.theme.settings &&
      window.theme.settings.cartType === "modal"
    ) {
      formData.append("sections", "cart-items,cart-footer,cart-item-count");
      formData.append("sections_url", window.location.pathname);
    }

    try {
      const cartAddUrl = "/cart/add";
      const res = await fetch("/cart/add", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        body: formData,
      });
      let data;
      const contentType = res.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        data = await res.json();
      } else {
        const text = await res.text();
        console.error("Unexpected response (not JSON):", text);
        btn.disabled = false;
        return;
      }

      if (!data.status) {
        if (
          window.theme &&
          window.theme.settings &&
          window.theme.settings.cartType === "modal"
        ) {
          document.body.dispatchEvent(
            new CustomEvent("shapes:cart:afteradditem", {
              bubbles: true,
              detail: { response: data, sourceId: btn.id },
            }),
          );
        } else {
          location.reload();
        }
      }
    } catch (err) {
      console.error(err);
    }
    btn.disabled = false;

    /*------ Custom code to toggle header colors -----*/
    const toggleHeaderBtns = document.querySelectorAll(
      ".header-links__toggle-menu",
    );
    toggleHeaderColors(toggleHeaderBtns);

    /*------load wishlist buttons after select filters------*/
    function syncWishlistState() {
      if (window.swat) {
        // Чекаємо, поки DOM оновиться після фільтрації
        setTimeout(function () {
          // 1. Повторна ініціалізація кнопок для нових елементів
          window.swat.initializeActionButtons(".product-tile");

          // 2. Отримання актуального списку обраного для поточного користувача
          window.swat.fetchWrtEventType(function (products) {
            // Цей метод автоматично розставить клас .swym-added
            // на всі кнопки, чиї product_id збігаються з вішлістом
          }, window.swat.EventTypes.addToWishlist);
        }, 600);
      }
    }

    // Слухаємо зміну URL та стандартні події оновлення фільтрів
    window.addEventListener("popstate", syncWishlistState);
    document.addEventListener("facet:updated", syncWishlistState);
    document.addEventListener("ajaxProductGridUpdate", syncWishlistState);
  },
  { capture: true },
);
